let productCounter = document.querySelector('[data-filter="counter"]');
if (productCounter)
    productCounter.innerHTML = document.querySelectorAll('[data-product]').length;

function setAvailableFilters() {
    document.querySelectorAll('input[name="filters[]"]').forEach(filter => {
        filter.disabled = true;
        filter.parentNode.classList.add('opacity-25');

        document.querySelectorAll(':not(.d-none)[data-product]').forEach(product => {
            if(product.querySelector('[data-filter="' + filter.value + '"]') !== null) {
                filter.disabled = false;
                filter.parentNode.classList.remove('opacity-25');
            }
        });
    });
}
setAvailableFilters();

function filterProductList() {
    let firstCheckedItem = document.querySelector('input[name="filters[]"]:checked');
    let applicationAccessoriesIncluded = document.querySelector('input[value="applicationAccessoriesIncluded"]:checked');

    let selectedFilters = document.querySelectorAll('input[name="filters[]"]:checked');
    let selectedFilterValues = [];
    for (let selectedFilter of selectedFilters) {
        selectedFilterValues.push(selectedFilter.value);
    }

    let countProducts = 0;
    document.querySelectorAll('[data-product]').forEach(item => {

        let productFilters = item.querySelectorAll('[data-filter]');
        let productFilterValues = [];
        for (let productFilter of productFilters) {
            if (applicationAccessoriesIncluded !== null && productFilter.classList.contains('application-yes'))
                productFilterValues.push(productFilter.getAttribute('data-filter'));
            if (applicationAccessoriesIncluded === null)
                productFilterValues.push(productFilter.getAttribute('data-filter'));
        }

        let productAppliesToFilters = (arr, target) => target.every(v => arr.includes(v));
        if(productAppliesToFilters(productFilterValues, selectedFilterValues) || !firstCheckedItem) {
            item.classList.add('d-block');
            item.classList.remove('d-none');
            countProducts++;
        } else {
            item.classList.add('d-none');
            item.classList.remove('d-block');
        }
        setAvailableFilters();
    });


    document.querySelector('[data-filter="counter"]').innerHTML = countProducts;

    let message = document.querySelector('[data-filter="message"]');
    if (message && countProducts <= 0) {
        message.classList.add('d-block');
        message.classList.remove('d-none');
    } else {
        message.classList.add('d-none');
        message.classList.remove('d-block');
    }

    let productFilterReset = document.querySelector('[data-filter="reset-all"]');
    if (productFilterReset) {
        if (countProducts < document.querySelectorAll('[data-product]').length)
            productFilterReset.classList.remove('d-none');
        else
            productFilterReset.classList.add('d-none');
    }
}

document.querySelectorAll('input[name="filters[]"],input[name="options[]"]').forEach(item => {
    item.addEventListener('change', event => {
        event.preventDefault();
        filterProductList();
    }, false);
});

let productFilterReset = document.querySelector('[data-filter="reset-all"]');
if (productFilterReset) {
    productFilterReset.addEventListener('click', () => {
        document.querySelectorAll('input[name="filters[]"],input[name="options[]"]').forEach(el => el.checked = false);
        filterProductList();
    });
}
